import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "~/atoms/dropdown-menu";
import { ManageFrameworkDropdown } from "~/molecules/ManageFrameworkDropdown";
import { ReorderTierModal } from "~/organisms/ReorderTierModal";
import { TierModal } from "~/organisms/TierModal";

export function ManageTiersDropdown() {
  const { t } = useTranslation();
  const [activeDialog, setActiveDialog] = useState<"create" | "reorder" | null>(
    null,
  );

  return (
    <>
      <ManageFrameworkDropdown label={t(($) => $.commons.buttons.manageTiers)}>
        <DropdownMenuItem onSelect={() => setActiveDialog("create")}>
          {t(($) => $.commons.buttons.createTier)}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => setActiveDialog("reorder")}>
          {t(($) => $.commons.buttons.reorderTiers)}
        </DropdownMenuItem>
      </ManageFrameworkDropdown>

      <TierModal
        open={activeDialog === "create"}
        onOpenChange={(open) => !open && setActiveDialog(null)}
      />
      <ReorderTierModal
        open={activeDialog === "reorder"}
        onOpenChange={(open) => !open && setActiveDialog(null)}
      />
    </>
  );
}
